import React from 'react';
import { motion } from 'framer-motion';

const testimonials = [
  {
    quote: "They didn't just design a room — they understood how we wanted to feel in it. Our home is finally a place we want to stay.",
    name: 'Priya & Arjun Mehta',
    project: 'Park Slope Residence'
  },
  {
    quote: "Every detail was considered before we even knew to ask. The result is warm, layered, and so completely us.",
    name: 'Daniel Roth',
    project: 'Tribeca Loft'
  },
  {
    quote: "Working with Forma felt like collaborating with a friend who happens to have extraordinary taste. We cannot recommend them enough.",
    name: 'Sofia & Marcus Lee',
    project: 'Sunday House'
  }
];

function TestimonialsSection() {
  return (
    <section className="testimonials-section" id="testimonials">
      <div className="section-wrap">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Kind words</p>
            <h2>
              What our clients
              <br />
              <em>say.</em>
            </h2>
          </div>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              className="testimonial-card"
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.55, delay: i * 0.12 }}
            >
              <span className="quote-mark">"</span>
              <blockquote>{t.quote}</blockquote>
              <figcaption>
                <strong>{t.name}</strong>
                <span>{t.project}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;
